import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import ExitToApp from "@material-ui/icons/ExitToApp";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { userDetail } from "../../config/userDetails";
import NavList from "../../constants/NavList";
import { logout } from "../../modules/user/redux/action";
import { isSuperAdmin, isCounterParty } from "../Common/CheckAuthorization";
import Logo from "../Logo";
import { Link, Redirect } from "react-router-dom";
const drawerWidth = 240;

const styles = theme => ({
  // root: {
  //   display: "flex"
  // },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    background: " #005458",
    borderRadius: "0 10px 10px 0",
    justifyContent: "space-between"
    // [theme.breakpoints.up('md')]: {
    //   backgroundColor: 'red',
    // },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: "hidden",
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 8 + 1
    },
    background: " #005458",
    borderRadius: "0 10px 10px 0",
    justifyContent: "space-between"
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3
  },
  IconsColor: {
    color: " #c8d9da"
  },
  textStyle: {
    color: " #c8d9da",
    fontSize: "16px",
    margin: 0
  },
  MainList: {
    padding: 0
  },
  active: {
    color: "red"
  },
  closeButton: {
    color: "white",
    marginLeft: "auto",
    alignSelf: "baseline",
    background: "transparent",
    border: "1px solid transparent",
    fontSize: "18px"
  }
});

class MiniDrawer extends React.Component {
  state = {
    open: false
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, showDrawer } = this.props;
    const navlinksList = isSuperAdmin()
    ? (userDetail().roleName!=""&&NavList[userDetail().roleName][0])
    : (userDetail().roleName!=""&&NavList[userDetail().roleName][isCounterParty()?0:(userDetail().planId || 0)]) || [];
  
return (
      <div
        className={` isweb ${classes.root} 
        ${showDrawer ? "mobileDrawer" : ""}`}
      >
        <CssBaseline />

        <Drawer
          variant="permanent"
          className={classNames(classes.drawer, {
            [classes.drawerOpen]: !this.props.DrawerReducer,
            [classes.drawerClose]: this.props.DrawerReducer
          })}
          classes={{
            paper: classNames({
              [classes.drawerOpen]: !this.props.DrawerReducer,
              [classes.drawerClose]: this.props.DrawerReducer
            })
          }}
          // className="vertical-navbar"
          open={!this.props.DrawerReducer}
        >
          <List>
            <div style={{ display: "flex" }}>
              <Logo isShowLabel={!this.props.DrawerReducer} />
              {showDrawer && (
                <button
                  onClick={this.props.handleClick}
                  className={classes.closeButton}
                  aria-label="Close Drawer"
                >
                  <FontAwesomeIcon icon={faTimesCircle} />
                </button>
              )}
            </div>
            {navlinksList!= null && navlinksList.map(item => {
              return (
                <ListItem
                  key={item.name}
                  classes={{
                    root: classNames(classes.MainList)
                  }}
                  style={{ marginTop: item.margin }}
                >
                  <NavLink className="verticalNavlink" to={item.link}>
                    <ListItemIcon
                      classes={{
                        root: classNames(classes.IconsColor)
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      classes={{
                        primary: classNames(classes.textStyle)
                      }}
                      primary={item.name}
                    />
                  </NavLink>
                </ListItem>
              );
            })}
          </List>
          <List style={{ marginTop: "25px" }}>
            <ListItem className="profileSectionLink">
              <FontAwesomeIcon size="2x" icon={faUserCircle} />
            </ListItem>
            <ListItem
              classes={{
                root: classNames(classes.MainList)
              }}
            >
              {!this.props.DrawerReducer && (
                <NavLink className="profileSectionLink" to="#">
                  <ListItemText
                    classes={{
                      primary: classNames(classes.textStyle)
                    }}
                    primary={`${userDetail().name} [${userDetail().userId}]`}
                  />
                </NavLink>
              )}
            </ListItem>
            <ListItem
              classes={{
                root: classNames(classes.MainList)
              }}
            >
              <a
                className="profileSectionLink"
                href=""
                onClick={() => {
                  this.props.logout();
                }}
              >
                <ListItemIcon
                  classes={{
                    root: classNames(classes.IconsColor)
                  }}
                >
                  <ExitToApp />
                </ListItemIcon>
                <ListItemText
                  classes={{
                    primary: classNames(classes.textStyle)
                  }}
                  primary="Logout"
                />
              </a>
            </ListItem>
            <ListItem>
              <span style={{ fontSize: 9, color: "#c8d9da" }}>Version-3.0</span>
            </ListItem>
          </List>
        </Drawer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userData: state,
    DrawerReducer: state.DrawerReducer.isExpanDrawer
  };
}
MiniDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  { logout }
)(withStyles(styles, { withTheme: true })(MiniDrawer));



// WEBPACK FOOTER //
// ./src/components/private/VerticalNavbar.js